let isMobileToggleBound = false;

function aboutNeighborhoodToggle() {
    const isMobile = $(window).width() < 1024;

    if (isMobile && !isMobileToggleBound) {
        $('.about_neighborhood .wp-block-heading').each(function (){
            const content = $(this).text();
            $(this).text('').append(`<button type="button" aria-expanded="false">${content}</button>`)
            $(this).siblings().attr('aria-hidden', 'true');
        });
        $('body').on('click.mobileToggle', '.about_neighborhood .wp-block-heading button', function (e) {
            e.preventDefault();
            $(this).parent().toggleClass('open');
            $(this).attr('aria-expanded', $(this).parent().hasClass('open') ? 'true' : 'false');
            $(this).parent().siblings().attr('aria-hidden', $(this).parent().hasClass('open') ? 'false' : 'true');
            $(this).parent().siblings().slideToggle(150);
        });
        isMobileToggleBound = true;
    } else if (!isMobile && isMobileToggleBound) {
        $('.about_neighborhood .wp-block-heading').each(function (){
            const content = $(this).text();
            $(this).text('').append(`${content}`)
            $(this).siblings().removeAttr('aria-hidden');
        });
        $('body').off('click.mobileToggle');
        isMobileToggleBound = false;
    }
}

$(document).ready(function () {
    aboutNeighborhoodToggle();
    $(window).on('resize', aboutNeighborhoodToggle);
});


let smallSliderNeighborhood = new Swiper(".about-neighborhood-swiper-thumb", {
    loop: true,
    spaceBetween: 10,
    slidesPerView: 4,
    watchSlidesProgress: true,
    on: {
        init(swiper) {
            updateThumbAccessibility(swiper);
        },
        slideChange(swiper) {
            updateThumbAccessibility(swiper);
        },
        progress(swiper) {
            updateThumbAccessibility(swiper);
        },
    },
});
let bigSliderNeighborhood = new Swiper(".about-neighborhood-swiper", {
    loop: true,
    spaceBetween: 10,
    navigation: {
        nextEl: ".about_neighborhood_swiper_next",
        prevEl: ".about_neighborhood_swiper_prev",
    },
    thumbs: {
        swiper: smallSliderNeighborhood,
    },
    on: {
        init() {
            updateThumbLabels(smallSliderNeighborhood);
        },
        slideChangeTransitionEnd() {
            updateThumbLabels(smallSliderNeighborhood);
        },
        slideChange() {
            updateThumbAccessibility(smallSliderNeighborhood);
        },
    }
});



$('body').on('click', '.about-neighborhood-swiper-thumb button', function (){
    bigSliderNeighborhood.slideTo($(this).parent().data('swiper-slide-index'));
});
